import { Any, Event, Obj } from "@kizmann/pico-js";
import NTableCellString from "@kizmann/nano-ui/src/table/src/table-cell/types/table-cell-string.jsx";

export default Obj.assign({}, NTableCellString, {

    name: 'NTableCellEdit',

    inject: {
        AppIndex: {
            default: undefined
        }
    },

    data()
    {
        return {
            editMode: false, editValue: ''
        };
    },

    mounted()
    {
        Event.bind('table-edit:discard', (uid) => {
            this.editMode = this.uid === uid;
        }, { uid: this.uid });
    },

    beforeUnmount()
    {
        Event.unbind('table-edit:discard', { uid: this.uid });
    },

    methods: {

        startEditMode()
        {
            [this.editValue, this.editMode] = [
                this.input, true
            ];

            Event.fire('table-edit:discard', this.uid);
        },

        cancelEditMode(data = null)
        {
            if ( ! Any.isNull(data) ) {
                Obj.assign(this.item, data);
            }

            this.editMode = false;
        },

        saveEditMode()
        {
            let func = Obj.get(this.column, 'modelValue.fn');

            if ( ! Any.isFunction(func) ) {
                return this.cancelEditMode();
            }

            let data = Obj.assign({}, this.item, {
                [this.column.prop]: this.editValue
            });

            let promise = func.call({}, data);

            if ( ! (promise instanceof Promise) ) {
                return this.cancelEditMode(data);
            }

            promise.then(() => {
                this.cancelEditMode(data);
            });
        }

    },

    renderEdit()
    {
        let cancelProps = {
            size: 'sm',
            type: 'primary',
            glass: true
        };

        cancelProps['onClick'] = () =>{
            this.cancelEditMode();
        };

        let cancelHtml = (
            <div class="n-table-edit__cancel">
                <NButton {...cancelProps}>{this.trans('Discard')}</NButton>
            </div>
        );

        let applyProps = {
            size: 'sm',
            type: 'primary',
            icon: 'fa fa-floppy-disk'
        };

        applyProps['onClick'] = () =>{
            this.saveEditMode();
        };

        let applyHtml = (
            <div class="n-table-edit__apply">
                <NButton {...applyProps}>{this.trans('Apply')}</NButton>
            </div>
        );

        let inputProps = {
            size: 'sm'
        };

        inputProps['onKeydown'] = (e) => {
            if ( e.keyCode === 13 ) {
                this.saveEditMode();
            }
        }

        let inputHtml = (
            <div class="n-table-edit__input">
                <NInput vModel={this.editValue} {...inputProps} />
            </div>
        );

        return (
            <div class="n-table-edit is-edit">
                {[inputHtml, applyHtml, cancelHtml]}
            </div>
        );
    },

    render()
    {
        if ( ! this.init ) {
            return null;
        }

        if ( this.editMode ) {
            return this.ctor('renderEdit')();
        }

        let editProps = {
            type: 'primary',
            size: 'xs',
            link: true,
        };

        editProps['onClick'] = () =>{
            this.startEditMode();
        };

        let editHtml = (
            <div class="n-table-edit__edit">
                <NButton {...editProps}>{this.trans('Edit')}</NButton>
            </div>
        );

        let labelText = (<span>{this.input}</span>);

        if ( Any.isEmpty(this.input) ) {
            labelText = (<i>{this.column.emptyText}</i>);
        }

        if ( this.$slots.default ) {
            labelText = this.slots.default();
        }

        let labelHtml = (
            <div class="n-table-edit__value">
                {labelText}
            </div>
        );


        return (
            <div class="n-table-edit">
                {[labelHtml, editHtml]}
            </div>
        );
    }

});